<div style="width: 100%; max-width: 700px">
  <sui-button variant="primary" (click)="copyText(textToCopy)">
    {{ "btn.copy-to-clipboard" | translate }}
  </sui-button>

  <pre #textToCopy style="overflow: auto; margin-block-start: 1rem">{{
    widget.chart_options
  }}</pre>
</div>
